module.exports = __webpack_public_path__ + "img/doc.8c18864e.svg";